export default __webpack_public_path__ + "static/media/2325.52aa0799.png";